import { Group, Indicator, Paper, Skeleton, Stack, Text } from "@mantine/core";
import type { ChecklistSummaryStats } from "./hooks/useChecklistSummaryQuery";
import { AlertCircle } from "./icons/AlertCircle";
import { CircleCheck } from "./icons/CircleCheck";

export interface ChecklistSummaryViewProps {
    stats?: ChecklistSummaryStats;
    isLoading: boolean;
}

export function ChecklistSummaryView({ stats, isLoading }: ChecklistSummaryViewProps) {
    return (
        <Paper bg="dark.7" p="lg" radius="md">
            <Stack>
                <Group justify="space-between">
                    <Text fw="bold" size="xs">
                        Checklist Summary
                    </Text>
                    <Group gap="xxs">
                        <Indicator size={6} processing />
                        <Text size="xxs" c="dark.2">
                            Live
                        </Text>
                    </Group>
                </Group>
                <Skeleton visible={isLoading} h={isLoading ? "206px" : undefined}>
                    <Stack gap={0}>
                        {stats == null ? (
                            <Text>Oh no! Something went wrong</Text>
                        ) : (
                            stats.checklistSummary.map(({ behavior, count }, i) => {
                                const percent = Math.round((count / stats?.totalEligibleSessions) * 100);

                                const isInvalidData = stats?.totalEligibleSessions === 0;
                                const isWarning = percent <= 75;

                                return (
                                    <Group
                                        key={behavior}
                                        justify="space-between"
                                        py="xxs"
                                        px="sm"
                                        c={isWarning ? "warning.0" : undefined}
                                        styles={{
                                            root: {
                                                borderTop:
                                                    i !== 0 ? "1px solid var(--mantine-color-dark-5)" : undefined,
                                            },
                                        }}
                                    >
                                        <Text fw={isWarning ? "bold" : undefined} size="xs">
                                            {behavior}
                                        </Text>
                                        {isInvalidData ? (
                                            <Text size="xs">N/A</Text>
                                        ) : (
                                            <Group gap="3xs">
                                                {isWarning ? <AlertCircle /> : <CircleCheck />}
                                                <Text size="xs">{percent}%</Text>
                                            </Group>
                                        )}
                                    </Group>
                                );
                            })
                        )}
                    </Stack>
                </Skeleton>
            </Stack>
        </Paper>
    );
}
